import RequestReloadModal from "../../views/modules/RequestReloadModal"

export default Vue => {
  Vue.component("RequestReloadModal", RequestReloadModal)
}
